import(/* webpackMode: "eager", webpackExports: ["RestaurantsLandingPageContent"] */ "/vercel/path0/apps/web/components/RestaurantsLandingPageContent.tsx");
